export default __webpack_public_path__ + "static/media/event-menu-panah.868fecb5.svg";